import DropdownSelector from 'components/DropdownSelector';
import { nwsAlertTypes } from 'features/Weather/features/WeatherAlerts/config/nwsAlertTypes.config';
import { useEffect } from 'react';

interface NWSAlertGAConditionProps {
  data: { value?: string; error?: boolean };
  setData: (data: any) => void;
  setError: (err: { message: string } | null) => void;
  readOnly?: boolean;
}

import { useState } from 'react';

const NWSAlertGACondition: React.FC<NWSAlertGAConditionProps> = ({
  data,
  setData,
  setError,
  readOnly = false,
}) => {
  // Find the index of the current value in nwsAlertTypes, default to 0
  const initialIndex = data.value ? nwsAlertTypes.indexOf(data.value) : 0;
  const [selectedAlertTypeIndex, setSelectedAlertTypeIndex] = useState(initialIndex);

  const handleSelectAlertType = (index: number) => {
    const nextAlertType = nwsAlertTypes[index];
    setData({
      ...data,
      value: nextAlertType || '',
      error: !nextAlertType,
    });
    setSelectedAlertTypeIndex(index);
    setError(!nextAlertType ? { message: 'Please select an alert type.' } : null);
  };

  return (
    <div className="d-flex flex-column w-100">
      <div className="global-action-builder-row d-flex flex-column p-3 rounded-2 m-2 align-items-stretch align-items-md-center">
        <label className="fs-6 mb-1 fw-medium w-100">NWS Alert:</label>
        <DropdownSelector
          options={nwsAlertTypes}
          selectedOption={selectedAlertTypeIndex}
          setSelected={handleSelectAlertType}
          closeOnSelect={true}
          contentStyle={{ maxHeight: 280, overflowY: 'auto' }}
        />
      </div>
    </div>
  );
};

export default NWSAlertGACondition;
